<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap2"><a id="page21"></a><a id="page22"><i>PART I<br/>THE SURGEONS</i></a></h1><a id="page22">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 8-chap2.vue?29003711